"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var classNames = require("classnames");
var elog = require("../../elog");
var url_helpers_1 = require("../../url_helpers");
var markdown_output_1 = require("./markdown_output");
var COMPONENT_NAME = 'Heading';
var Heading = /** @class */ (function (_super) {
    tslib_1.__extends(Heading, _super);
    function Heading() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Heading.prototype.getBackgroundStyle = function () {
        if (!this.props.backgroundImageKey)
            return;
        var img = url_helpers_1.imageUploadURL(this.props.backgroundImageKey);
        return { backgroundImage: "url(" + img + ")" };
    };
    Heading.prototype.render = function () {
        var classes = classNames('cms-heading', { 'cms-heading--with-image': !!this.props.backgroundImageKey }, { 'cms-heading--left': this.props.alignment === 'left' }, { 'cms-heading--center': this.props.alignment === 'center' });
        try {
            return (React.createElement("div", { className: classes, style: this.getBackgroundStyle(), id: this.props.jumplinkSlug },
                React.createElement("div", { className: "cms-heading__inner" },
                    React.createElement("div", { className: "cms-heading__text" },
                        React.createElement(markdown_output_1.default, { htmlTag: "h3", className: "cms-heading__title", text: this.props.heading, textHtml: this.props.headingHtml }),
                        React.createElement(markdown_output_1.default, { htmlTag: "h4", className: "cms-heading__subtitle", text: this.props.subheading, textHtml: this.props.subheadingHtml })))));
        }
        catch (e) {
            elog.error("RenderError (" + COMPONENT_NAME + ")", {}, e);
            return null;
        }
    };
    return Heading;
}(React.Component));
exports.default = Heading;
//# sourceMappingURL=heading.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/cms/components/heading.js
// module id = YnEm
// module chunks = 0 2 6 20